/**
 * The glyph on a suggestion chip.
 *
 * Replaces the abstract shapes (pill/circle/square/corner) that came before:
 * a coloured square carried no information about "the 24 hour window expired".
 * Each icon names the kind of problem the chip is about, so the row can be read
 * before it is read.
 */

const PATHS = {
  clock: "M8 4v4l2.5 1.5M14 8A6 6 0 112 8a6 6 0 0112 0z",
  document:
    "M9 1.5H4.5A1.5 1.5 0 003 3v10a1.5 1.5 0 001.5 1.5h7A1.5 1.5 0 0013 13V5.5L9 1.5zM9 1.5V5a.5.5 0 00.5.5H13",
  gauge: "M2.5 12a6 6 0 1111 0M8 12l3-3.5",
  user: "M12.5 13.5a4.5 4.5 0 00-9 0M8 8a2.75 2.75 0 100-5.5A2.75 2.75 0 008 8z",
  image:
    "M2.5 3.5h11v9h-11v-9zM2.5 10l3-2.5 3 2.5 2-1.5 3 2.5M6 6.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
  shield: "M8 1.75l5 2v4c0 3-2.1 5.5-5 6.5-2.9-1-5-3.5-5-6.5v-4l5-2z",
  phone:
    "M3 3.5l2-1 1.75 2.5-1.25 1.25a8 8 0 003.25 3.25L10 8.25 12.5 10l-1 2c-4 .5-9-4.5-8.5-8.5z",
  megaphone: "M11.5 3.5v9l-7-2.5v-4l7-2.5zM4.5 6H3a1.5 1.5 0 000 3h1.5M6 10v3",
  retry: "M13 8a5 5 0 11-1.6-3.7M13.5 2v3h-3",
  alert: "M8 5.5v3.5M8 11.5h.01M7.1 2.4L1.6 12a1 1 0 00.9 1.5h11a1 1 0 00.9-1.5L8.9 2.4a1 1 0 00-1.8 0z",
  plug: "M6 2v3.5M10 2v3.5M4.5 5.5h7V8a3.5 3.5 0 01-7 0V5.5zM8 11.5V14",
};

export default function SuggestionIcon({ icon, color }) {
  const path = PATHS[icon] || PATHS.alert;

  return (
    <svg
      viewBox="0 0 16 16"
      aria-hidden="true"
      className="h-3.5 w-3.5 flex-none"
      style={{ color }}
    >
      <path
        d={path}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
